import { TableBody, TableCell, TableRow, Table as TableUi } from '@lingoda/ui';

interface Props {
    data: string[][];
}

const Table = ({ data }: Props) => (
    <TableUi size="small" disableBorderBottom>
        <TableBody>
            {data.map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                    {row.map((cell, cellIndex) => (
                        <TableCell
                            edge={cellIndex === 0 && 'start'}
                            key={cellIndex}
                            sx={{ color: 'inherit' }}
                        >
                            {cell}
                        </TableCell>
                    ))}
                </TableRow>
            ))}
        </TableBody>
    </TableUi>
);

export default Table;
